export default __webpack_public_path__ + "static/hero-min-2014691de4a7ead8da530f8dcdd9b53a.png";